<div class="workflow-step-header-outer">
    <div class="workflow-step-header">
        <span class="step">{{ currentPage.pageNumber }}</span>
        <div class="step-name">{{ currentPage.title }}</div>
        <div class="step-time" *ngIf="previousDay">{{ previousDay }} <span class="step-completed-by" *ngIf="showEditedName()">/ Created by {{ getShiftRecord()?.user?.firstName }} {{ getShiftRecord()?.user?.lastName }}</span></div>
    </div>
</div>
    